export interface IDataroomTwoFactorAuthenticationContext {
  setTwoFactorAccessError: (hasError: boolean) => void,
  setModalData: (data: Record<string, unknown>) => void,
}

// DI key of the two-factor context value. Kept out of the 'use client' context module, so that
// code reachable from the server (JSON-RPC interceptors) can reference it without dotting into
// a client module — see DataroomTenantContextSymbol in @dataroom/tenant/types.
export const DataroomTwoFactorAuthenticationContextSymbol = Symbol('DataroomTwoFactorAuthenticationContext');
